<template>
  <div id="app">
    <router-view />
    <div class="version">{{ RELEASE_VERSION }}</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { RELEASE_VERSION } from '@/utils/constants'

export default {
  name: 'App',
  data() {
    return {
      RELEASE_VERSION
    }
  },
  computed: {
    ...mapGetters(['showLoading'])
  },
  mounted() {
    // this.startListenVersionChange()
    this.updateDevice(navigator.userAgent)
  },
  methods: {
    ...mapActions('version', ['startListenVersionChange']),
    ...mapActions('track', ['updateDevice'])
  }
}
</script>

<style lang="less" scoped>
.version {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 1;
  padding: 0 10px 10px;
  font-size: 10px;
  color: rgba(211, 211, 211, 0.7);

  &::selection {
    color: red;
  }
}
</style>
